import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import unslug from "unslug";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { createTitle } from "@/functions/createTitle";

export default function MeetOurTeam({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps() {
  const page = simple_pages_helper.find("meet-our-team");

  if (!page) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      meta: {
        title: createTitle("About us"),
      },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              {
                label: "About us",
                href: "/about-us",
              },
              {
                label: "Meet our team",
                href: "/about-us/meet-our-team",
              },
            ],
          },
        },
        {
          component: "Header",
          id: "Header",
          props: {
            className: page.cover_image ? "bg-primary text-white" : "bg-light text-tertiary",
            title: page.title,
            description: page.description ?? null,
            img: page.cover_image ?? null,
          },
        },
        Array.isArray(page.carousel_items) && {
          component: "LogoCarousel",
          id: "LogoCarousel",
          props: {
            title: page.carousel_title ?? null,
            items: (page.carousel_items ?? []).map((i) => ({
              title: i["Title"],
              img: i["Image"] ?? null,
              href: i["Link"] ?? "#",
            })),
            visibleCount: page.carousel_items_per_slide ?? 1,
          },
        },
        {
          component: "RichText",
          id: "Intro",
          props: {
            className: "bg-primary text-white py-4 py-md-5",
            body: page.intro ?? null,
          },
        },
        Array.isArray(page.grid_buttons) && {
          component: "GridButtonsGrid",
          id: "GridButtonsGrid",
          props: {
            title: page.grid_buttons_title ?? null,
            items: page.grid_buttons.map((i) => ({
              title: i["Title"],
              img: i["Image"] ?? null,
              href: i["Link"] ?? "#",
            })),
          },
        },

        Array.isArray(page.collapsible_section_items) && {
          component: "CollapsibleSection",
          id: "CollapsibleSection",
          props: {
            title: page.collapsible_section_title ?? null,
            description: page.collapsible_section_description ?? null,
            items: page.collapsible_section_items.map((i) => ({
              title: i["Title"] ?? null,
              body: i["Body"] ?? null,
            })),
          },
        },
        {
          component: "RichText",
          id: "Body",
          props: {
            body: page.body ?? null,
            ctas: Array.isArray(page.buttons)
              ? page.buttons.map((i) => ({
                  label: i["Label"] ?? "Read more",
                  href: i["Link"] ?? "#",
                  variant: i["Variant"] ?? "secondary",
                }))
              : [],
          },
        },
        ...(Array.isArray(page.narrative_panels)
          ? page.narrative_panels.map((i, k) => ({
              component: "NarrativePanel",
              id: `NarrativePanel-${k}`,
              props: {
                className: `py-4 py-md-5 bg-${i["Background Color"] ?? "white"} text-${i["Text Color"] ?? "dark"}`,
                title: i["Title"] ?? null,
                description: i["Description"] ?? null,
                img: i["Image"] ?? null,
                cta: {
                  label: i["Button Label"] ?? "Read more",
                  href: i["Button Link"] ?? "#",
                  variant: i["Button Variant"] ?? "secondary",
                },
                reverse: i["Reverse"] ?? false,
              },
            }))
          : []),
        {
          component: "RichText",
          id: "ClosingText",
          props: {
            body: page.closing_text ?? null,
          },
        },
        Array.isArray(page.bottom_tiles) && {
          component: "TeamTiles",
          id: "TeamTiles",
          props: {
            tiles: page.bottom_tiles.map((each) => ({ title: each.title, link: each.link, image: each.image })),
            title: page.bottom_tiles_title ?? null,
          },
        },
      ],
    },
  };
}
